import React from "react";
import InputField from "../../components/InputField";
import useNewSpecFormHandler from "../../components/hooks/new-spec-form-handler";

const NewSpecTab = ({ product }) => {
  const { errors, handleChange, handleSubmit, touched, values } =
    useNewSpecFormHandler(product);
  return (
    <div>
      <form className="">
        <div className="space-y-4">
          <InputField
            label="Quantity"
            id="quantity"
            type="number"
            value={values.quantity}
            onChange={handleChange("quantity")}
            errorMsg={touched.quantity ? errors.quantity : undefined}
            placeholder="24"
          />
          <InputField
            label="Amount"
            id="amount"
            type="number"
            value={values.amount}
            onChange={handleChange("amount")}
            errorMsg={touched.amount ? errors.amount : undefined}
            placeholder="amount"
          />
          <InputField
            label="Size"
            id="size"
            type="text"
            value={values.size}
            onChange={handleChange("size")}
            errorMsg={touched.size ? errors.size : undefined}
            placeholder="15.6 (inches)"
          />
        </div>
        <div className="mt-4">
          <button
            onClick={handleSubmit}
            className="block w-full py-2 text-center text-primary bg-transparent border border-primary rounded hover:border-gray-300 hover:text-primary transition uppercase font-roboto font-medium"
          >
            Add spec
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewSpecTab;
